import productViewNegotiatePriceHtml from './productviewnegotiateprice.component.html';
import './productviewnegotiateprice.component.scss';

class ProductViewNegotiatePriceController {
    constructor($scope, $http, SnackbarService) {
        'ngInject';

        this.$scope = $scope;
        this.$http = $http;
        this.SnackbarService = SnackbarService;

        this.productName = null;
        this.loading = false;
        this.showAllErrors = false;

        this.data = {
            links: '',
            comment: '',
            email: '',
            phone: ''
        };

        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        this.dataValidations = {
            links: () => this.data.links.length > 0,
            comment: () => this.data.comment.length > 0,
            email: () => emailRegex.test(String(this.data.email).toLowerCase()),
            phone: () => this.data.phone.length === 0 || this.data.phone.length >= 9,
        };
    }

    $onInit() {
        this.productName = this.productName;

        this.productId = this.productId;
        this.variantId = this.variantId ? this.variantId : 0;

        this.data.productName = this.productName;
        this.data.productId = this.productId;
        this.data.variantId = this.variantId;
    }

    isValid() {
        for (const validatorFnName in this.dataValidations) {
            if (!this.dataValidations[validatorFnName]()) return false;
        }

        return true;
    }

    save() {
        this.showAllErrors = true;

        if (!this.isValid()) return;

        this.loading = true;

        this.$http.post(
            '/ajax/products/productNegotiatePrice',
            this.data
        ).then(
            (response) => {
                this.loading = false;

                this.$scope.$parent.$ctrl.close();

                this.SnackbarService.add(response.data.message.content, response.data.message.type, true, 3000);
            },
            (error) => {
                this.loading = false;

                this.SnackbarService.add('Wystąpił nieoczekiwany błąd!', 'error', true, 3000);
            }
        );
    }

    close() {
        this.$scope.$parent.$ctrl.close();
    }
}

let productViewNegotiatePriceComponent = {
    bindings: {
        productId: '<',
        variantId: '<',
        productName: '@'
    },
    template: productViewNegotiatePriceHtml,
    controller: ProductViewNegotiatePriceController
}

export default productViewNegotiatePriceComponent;
